import domReady from '@wordpress/dom-ready';

function syncListingSelectAccessibility() {
  const wrappers = document.querySelectorAll(
    'label.filters-popup__sort-item[for], label.programs-courses-listing__results-heading__dropdown-wrapper[for]'
  );

  wrappers.forEach((wrapper) => {
    const select = wrapper.querySelector('select');
    const selectId = wrapper.htmlFor;

    if (!select || !selectId) {
      return;
    }

    select.removeAttribute('aria-labelledby');
    select.removeAttribute('aria-label');
    select.id = selectId;
  });
}

function queueListingSelectAccessibilitySync() {
  if ('function' === typeof window.requestAnimationFrame) {
    window.requestAnimationFrame(syncListingSelectAccessibility);
    return;
  }

  window.setTimeout(syncListingSelectAccessibility, 0);
}

function syncMobileFacetRadioGroups() {
  const mobileGroups = document.querySelectorAll(
    '.filters-popup__radio-group[data-mobile-facet]'
  );

  mobileGroups.forEach((group) => {
    const facetName = group.dataset.mobileFacet;
    const wrapper = group.closest('.filters-popup__sort-item');
    const select = wrapper?.querySelector('select');
    const FWP = window.FWP;
    let currentValue = select?.value || '';

    if (FWP) {
      if (
        'programs_per_page' === facetName ||
        'courses_per_page' === facetName
      ) {
        currentValue =
          'default' !== FWP.extras?.per_page && FWP.extras?.per_page
            ? String(FWP.extras.per_page)
            : currentValue;
      } else if (Array.isArray(FWP.facets?.[facetName])) {
        currentValue = FWP.facets[facetName][0] || currentValue;
      }
    }
    const radios = group.querySelectorAll('input[type="radio"]');

    radios.forEach((radio) => {
      radio.checked = radio.value === currentValue;
    });
  });
}

function bindMobileFacetRadioGroups() {
  const mobileRadios = document.querySelectorAll(
    '.filters-popup__radio-group[data-mobile-facet] input[type="radio"]'
  );

  mobileRadios.forEach((radio) => {
    if (radio.dataset.mobileFacetBound) {
      return;
    }

    radio.dataset.mobileFacetBound = 'true';
    radio.addEventListener('change', (event) => {
      const target = event.currentTarget;
      const group = target.closest('.filters-popup__radio-group');
      const wrapper = target.closest('.filters-popup__sort-item');
      const select = wrapper?.querySelector('select');
      const facetName = group?.dataset.mobileFacet;
      const FWP = window.FWP;

      if (!target.checked) {
        return;
      }

      if (FWP && facetName) {
        if (
          'programs_per_page' === facetName ||
          'courses_per_page' === facetName
        ) {
          FWP.extras.per_page = target.value;
          FWP.soft_refresh = true;
          FWP.autoload();
        } else {
          const facetSelects = document.querySelectorAll(
            `.facetwp-facet-${facetName} select`
          );

          facetSelects.forEach((facetSelect) => {
            facetSelect.value = target.value;
          });

          FWP.frozen_facets[facetName] = 'hard';
          FWP.autoload();
        }
      } else {
        if (!select) {
          return;
        }

        if (select.tomselect) {
          select.tomselect.setValue(target.value);
          select.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          select.value = target.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  });
}

// Sort and per-page facets are always active by default — exclude them
// from the selections check so they don't trigger "Filter by: Clear all".
const defaultFacets = new Set([
  'programs_sort',
  'courses_sort',
  'programs_per_page',
  'courses_per_page',
  'per_page',
]);

function doesFacetHasSelections() {
  const FWP = window.FWP;
  let facetSelections = false;

  if (FWP) {
    Object.entries(FWP.facets).forEach(([name, facet]) => {
      if (defaultFacets.has(name)) {
        return;
      }
      if (0 < facet.length) {
        facetSelections = true;
      }
    });
  }

  return facetSelections;
}

// Always enforce default A-Z sort on the programs listing.
// facetwp_preload_url_vars only runs on initial page load, not on AJAX refreshes
// (e.g. after "Clear all"). This listener ensures programs_sort is never sent empty.
document.addEventListener('facetwp-refresh', () => {
  const FWP = window.FWP;
  if (!FWP || !document.querySelector('.facetwp-facet-programs_sort')) {
    return;
  }
  if (
    !Array.isArray(FWP.facets.programs_sort) ||
    0 === FWP.facets.programs_sort.length
  ) {
    FWP.facets.programs_sort = ['program_name'];
  }
});

// Always enforce default A-Z sort on the courses listing.
// Same reasoning as programs_sort above.
document.addEventListener('facetwp-refresh', () => {
  const FWP = window.FWP;
  if (!FWP || !document.querySelector('.facetwp-facet-courses_sort')) {
    return;
  }
  if (
    !Array.isArray(FWP.facets.courses_sort) ||
    0 === FWP.facets.courses_sort.length
  ) {
    FWP.facets.courses_sort = ['subject_name_asc'];
  }
});

document.addEventListener('facetwp-refresh', () => {
  const btn = document.querySelector('.filters-popup__view-results');
  if (btn) {
    btn.classList.add('is-loading');
  }
});

function bindCourseAccordions() {
  const courseAccordions = document.querySelectorAll('.courseAccordion');

  courseAccordions.forEach((courseAccordion) => {
    const toggle = courseAccordion.querySelector('.courseAccordionToggle');

    if (!toggle || toggle.dataset.courseAccordionBound) {
      return;
    }

    toggle.dataset.courseAccordionBound = 'true';
    toggle.addEventListener('click', () => {
      const isOpen = courseAccordion.classList.contains('opened');

      courseAccordion.classList.toggle('opened', !isOpen);
      toggle.setAttribute('aria-expanded', String(!isOpen));
    });
  });
}

function updatePerPageLabels() {
  const perPageToggles = document.querySelectorAll(
    '.accordionToggle[data-label-template]'
  );
  if (!perPageToggles.length) {
    return;
  }

  const perPage = window.FWP?.settings?.pager?.per_page;
  if (null === perPage || undefined === perPage) {
    return;
  }

  perPageToggles.forEach((toggle) => {
    const label = toggle.querySelector('.toggle-label');
    if (label) {
      label.textContent = toggle.dataset.labelTemplate.replace('%d', perPage);
    }
  });
}

function updateViewResultsCount() {
  const btn = document.querySelector(
    '.filters-popup__view-results[data-count-label]'
  );
  if (!btn) {
    return;
  }

  const pager = window.FWP?.settings?.pager;
  // Courses are grouped by subject code, so `total_rows` reflects the
  // subject code count, not the course count; prefer `total_courses`
  // (added by the theme's facetwp_pager_args hook) when it's present.
  const total = pager?.total_courses ?? pager?.total_rows;
  if (null === total || undefined === total) {
    return;
  }

  const label = btn.querySelector('.filters-popup__view-results__label');
  if (label) {
    label.textContent = btn.dataset.countLabel.replace('%d', total);
  }
}

document.addEventListener('facetwp-loaded', () => {
  queueListingSelectAccessibilitySync();
  syncMobileFacetRadioGroups();
  bindCourseAccordions();
  updateViewResultsCount();
  updatePerPageLabels();

  const viewResultsBtn = document.querySelector('.filters-popup__view-results');
  if (viewResultsBtn) {
    viewResultsBtn.classList.remove('is-loading');
  }

  const selectionsWrapper = document.querySelector('.selectionsWrapper');
  const mainReset = document.querySelector(
    '.programs-courses-listing__filters .facetwp-reset'
  );
  // const popupView = document.querySelector('.filters-popup__view-results');
  const hasSelections = doesFacetHasSelections();

  if (selectionsWrapper) {
    if (hasSelections) {
      selectionsWrapper.classList.add('visible');
    } else {
      selectionsWrapper.classList.remove('visible');
    }
  }

  if (mainReset) {
    if (hasSelections) {
      mainReset.removeAttribute('disabled');
    } else {
      mainReset.setAttribute('disabled', 'true');
    }
  }

  // if (popupView) {
  //   if (hasSelections) {
  //     popupView.removeAttribute('disabled');
  //   } else {
  //     popupView.setAttribute('disabled', 'true');
  //   }
  // }
});

domReady(() => {
  queueListingSelectAccessibilitySync();
  bindMobileFacetRadioGroups();
  syncMobileFacetRadioGroups();
  bindCourseAccordions();
  updateViewResultsCount();

  const filterAccordions = document.querySelectorAll('.listingFilterAccordion');
  const resetBtns = document.querySelectorAll('.customReset');
  const popupToggle = document.querySelector('.filters-popup-toggle');
  const popupClose = document.querySelector('.filters-popup-close');
  const popupView = document.querySelector('.filters-popup__view-results');
  const popup = document.querySelector('#filters-popup');

  if (0 < resetBtns.length && window.FWP) {
    resetBtns.forEach((resetBtn) => {
      resetBtn.addEventListener('click', () => {
        window.FWP.reset();
      });
    });
  }

  if (0 < filterAccordions.length) {
    filterAccordions.forEach((filterAccordion) => {
      const toggle = filterAccordion.querySelector('.accordionToggle');

      toggle.addEventListener('click', () => {
        if (filterAccordion.classList.contains('opened')) {
          filterAccordion.classList.remove('opened');
          toggle.setAttribute('aria-expanded', 'false');
        } else {
          filterAccordion.classList.add('opened');
          toggle.setAttribute('aria-expanded', 'true');
        }
      });
    });

    if (window.innerWidth < 992) {
      filterAccordions.forEach((filterAccordion) => {
        if (filterAccordion.classList.contains('opened')) {
          filterAccordion.classList.remove('opened');
          filterAccordion
            .querySelector('.accordionToggle')
            .setAttribute('aria-expanded', 'false');
        }
      });
    }
  }

  if (popup && popupToggle) {
    function closeFilterPopup() {
      popup.classList.remove('opened');
      document.documentElement.classList.remove('lockedPosition');

      if (0 < filterAccordions.length) {
        filterAccordions.forEach((filterAccordion) => {
          if (filterAccordion.classList.contains('opened')) {
            filterAccordion.classList.remove('opened');
            filterAccordion
              .querySelector('.accordionToggle')
              .setAttribute('aria-expanded', 'false');
          }
        });
      }
    }

    function openFilterPopup() {
      popup.classList.add('opened');
      document.documentElement.classList.add('lockedPosition');
    }

    popupToggle.addEventListener('click', () => {
      if (popup.classList.contains('opened')) {
        closeFilterPopup();
      } else {
        openFilterPopup();
      }
    });

    popupClose.addEventListener('click', () => {
      if (popup.classList.contains('opened')) {
        closeFilterPopup();
      }
    });

    popupView.addEventListener('click', () => {
      if (popup.classList.contains('opened')) {
        closeFilterPopup();
        document.querySelector('.facetwp-template').scrollIntoView();
      }
    });
  }
});
